/**
 * 管理者パスワードの条件。会社登録とパスワード再設定で同じものを使う。
 *
 * 半角英数字・記号に限るのは、ひらがななどを許すと、登録時（表示に切り替えて入力）は
 * 打てても、ログイン時の伏せ字の欄では日本語入力が効かずに打てない恐れがあるため。
 * 6文字は Firebase Auth の下限に合わせている。
 * サーバー側（functions/src/adminPasswordRule.ts）も同じ条件で弾く。
 */
export const MIN_ADMIN_PASSWORD_LENGTH = 6;

/** 入力欄の下に出す条件の説明 */
export const ADMIN_PASSWORD_RULE_LABEL = `半角英数字・記号で${MIN_ADMIN_PASSWORD_LENGTH}文字以上`;

/** 条件を満たさないときのメッセージ */
export const ADMIN_PASSWORD_RULE_ERROR = `管理者パスワードは、${ADMIN_PASSWORD_RULE_LABEL}にしてください`;

// 半角の英数字・記号（スペースを除く ! 〜 ~）
const ALLOWED = /^[\x21-\x7E]+$/;

export function isValidAdminPassword(password: string): boolean {
  return password.length >= MIN_ADMIN_PASSWORD_LENGTH && ALLOWED.test(password);
}
